import React, { useContext } from 'react'
import { IFacilityProfile } from 'react-angle-dashboard-components'

export const FacilityProfileContext = React.createContext<IFacilityProfile>(
  {} as IFacilityProfile
)

export const useFacilityProfile = () => useContext(FacilityProfileContext)
